<template>
  <div>
  <v-card class="mx-auto content-personal pb-5" 
    style="border-radius: 0px; align-items: center;"
    color="#F1F2F6"
  >
    <v-card-title class="headline page-title">
      <p id="cys" style="text-align: center; width: 100%;">Совет молодых ученых МААН</p>
    </v-card-title>


    <v-card-text class="pa-12 pt-0 pb-0">
      <p style="text-align: justify; font-size: 22px; text-indent: 10px;">
        Совет молодых учёных в рамках Международной ассоциации академий наук является платформой, которая объединяет молодых учёных из организаций МААН с целью содействия их развитию, обмену знаниями и опытом, а также участию в научных исследованиях и проектах. Этот орган стремится к привлечению молодых талантливых специалистов к активной научной и научно-популяризаторской деятельности.
      </p>
      <p style="text-align: justify; font-size: 22px; text-indent: 10px;">
        В целях организации деятельности Совета молодых учёных МААН функционирует Бюро совета молодых учёных МААН. Бюро руководит общей деятельностью совета и реализует решения общего собрания.
      </p>
    </v-card-text>

    <v-card-title class="headline page-title pb-0">
      <p style="text-align: center; width: 100%;">Миссия</p>
    </v-card-title>
    <v-sheet
      color="#F1F2F6"
      class="d-flex flex-wrap bg-surface-variant"
      style="justify-content: center;"
    >
      <v-sheet
        color="#F1F2F6"
        min-width="475"
        v-for="task in missions" :key="task.id"
        class="pa-2 rounded-xxl"
        >
        <v-card
          class="person-card rounded-xxl ma-0 pa-6  d-flex flex-column"
          elevation="4"
          rounded="xxl"
          width="475"
          height="250"
          style="border-radius: 24px !important;"
        >
        <!-- star-three-points -->
        
          <v-card
            class="person-card rounded-xxl"
            width="40"
            height="40"
            color="#FFE1C0"
            style="border-radius: 16px !important; padding: 2px !important;"
          >
            <v-icon large left color="#FF8600">mdi-star-three-points</v-icon>

          </v-card>

        <v-card-subtitle
          class="mt-auto pa-0 pl-2"
        >
          {{ task.text }}
        </v-card-subtitle>
        
        </v-card>
      </v-sheet>
    </v-sheet>



    <v-card-title class="headline page-title pt-9 pb-0" >
      <p id="tasks" style="text-align: center; width: 100%;">Цели и задачи</p>
    </v-card-title>
    
    <v-sheet
      color="#F1F2F6"
      class="d-flex flex-wrap bg-surface-variant"
      style="justify-content: center;"
    >
      <v-sheet
        color="#F1F2F6"
        min-width="475"
        v-for="task in tasks" :key="task.id"
        class="pa-2 rounded-xxl"
        >
        <v-card
          class="person-card rounded-xxl ma-0 pa-6  d-flex flex-column"
          elevation="4"
          rounded="xxl"
          width="475"
          height="250"
          style="border-radius: 24px !important;"
        >
        <!-- star-three-points -->
        
          <v-card
            class="person-card rounded-xxl"
            width="40"
            height="40"
            color="#FFE1C0"
            style="border-radius: 16px !important; padding: 2px !important;"
          >
            <v-icon large left color="#FF8600">mdi-star-three-points</v-icon>

          </v-card>

        <v-card-subtitle
          class="mt-auto pa-0 pl-2"
        >
          {{ task.text }}
        </v-card-subtitle>
        
        </v-card>
      </v-sheet>
    </v-sheet>



    <v-card-title class="headline page-title pt-9 pb-0">
      <p id="docs" style="text-align: center; width: 100%;">Полезные документы</p>
    </v-card-title>
    
    <v-sheet
      color="#F1F2F6"
      class="d-flex flex-wrap bg-surface-variant"
      style="justify-content: center;"
    >
      <v-sheet
        color="#F1F2F6"
        min-width="310"
        v-for="task in docs" :key="task.id"
        class="pa-2 rounded-xxl"
        >
        <v-card
          class="person-card rounded-xxl ma-0 pa-6  d-flex flex-column"
          elevation="4"
          rounded="xxl"
          width="310"
          height="200"
          style="border-radius: 24px !important;"
        >
        <!-- star-three-points -->
        
          <v-card
            class="person-card rounded-xxl pa-2"
            width="40"
            height="40"
            color="#FFE1C0"
            style="border-radius: 16px !important;"
          >
            <v-icon 
              width="40"
              height="40"
              left color="#FF8600"
            >mdi-file-document</v-icon>

          </v-card>

        <v-card-subtitle
          class="mt-8 pa-0 pl-2"
        >
          {{ task.text }}
        </v-card-subtitle>
        
        <v-spacer></v-spacer>
        <v-card-actions class="mt-auto pa-0">
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text
              @click="get_file(task)">{{ "Скачать" }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-sheet>
    </v-sheet>



  </v-card>
  </div>
</template>
<script>


export default {
  name: 'About',
 
  beforeMount() {
  },

  data() {
    return {
      docs: [
      {
          id: 1,
          text: 'Положение об учреждении СМУ МААН',
        }, 
        {
          id: 2,
          text: 'Отчёт о проделанной работе',
        }, 
        {
          id: 3,
          text: 'Архив',
        }, 
      ],

      missions: [
      {
          id: 1,
          text: 'Объединить молодых учёных из организаций МААН и привлечь молодых талантливых специалистов к активной научной и научно-популяризаторской деятельности',
        }, 
        {
          id: 2,
          text: 'Объединить молодых учёных из организаций МААН и привлечь молодых талантливых специалистов к активной научной и научно-популяризаторской деятельности',
        }, 
      ],

      tasks: [
        {
          id: 1,
          text: 'Интеграция молодых учёных в рамках приоритетных направлений деятельности МААН',
        }, 
        {
          id: 2,
          text: 'Обеспечение научного сотрудничества между молодыми учёными организаций-членов МААН',
        }, 
        {
          id: 3,
          text: 'Развитие научного и творческого потенциала молодёжи организаций — членов МААН, содействие профессиональному росту, активному участию молодых учёных в фундаментальных и прикладных научных исследованиях',
        }, 
        {
          id: 4,
          text: 'Активизация международного сотрудничества и популяризации науки, в том числе: организация конференций, семинаров, научных школ, конкурсов и других научных и научно-практических мероприятий для молодых учёных организаций-членов МААН, а также содействие изданию материалов по результатам их проведения',
        }, 
        {
          id: 5,
          text: 'Содействие формированию совместных научно-исследовательских проектов и проведению мероприятий с Советами молодых учёных и аналогичными им структурами иных научных организаций в интересах МААН',
        }, 
        {
          id: 6,
          text: 'Представление перед Советом МААН интересов молодых учёных организаций — членов МААН в соответствии с направлениями деятельности',
        }, 
      ],
      members: [],
    }
  },

  components: {
  },

  methods: {
    get_file(file){

    },

    show_person_card(person){
      this.current_person = person
      this.person_dialog = true
    },
  }

};
</script>

